import { makeAutoObservable } from 'mobx';
import { ApiGetBonusBalanceProgressResponse200Type } from 'src/api_openapi/v2/bonus-engine/apiGetBonusBalanceProgress';
import { Amount } from 'src_common/common/amount/Amount';

export class BonusBalanceProgressModel {
    public constructor(private readonly data: ApiGetBonusBalanceProgressResponse200Type) {
        makeAutoObservable(this);
    }

    public get totalRequiredPlaythrough(): Amount {
        return new Amount(this.data.totalRequiredPlaythrough.toString());
        //return this.data.totalRequiredPlaythrough;
    }

    public get currentProgress(): Amount {
        return new Amount(this.data.currentProgress.toString());
        //return this.data.currentProgress;
    }

    public get remainingPlaythrough(): Amount {
        return new Amount(this.data.remainingPlaythrough.toString());
        //return this.data.remainingPlaythrough;
    }

    public get bonusStatus(): string {
        return this.data.bonusStatus;
    }
}
